"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unionType = void 0;
const index_1 = require("./index");
const flatten_union_declaration_1 = require("./flatten-union-declaration");
const caster_cache_1 = require("./caster-cache");
const actual_type_1 = require("./actual-type");
function unionType(declaration, validateOptions, circularCache = caster_cache_1.createCache()) {
    if (declaration === null || typeof declaration !== 'object') {
        throw new Error('First argument (declaration) must be an Object.');
    }
    const circularCaster = circularCache.get(declaration);
    if (circularCaster !== undefined) {
        return circularCaster;
    }
    const { type, declarations } = declaration;
    if (type !== 'Union') {
        throw new Error('"type" property on declaration must be "Union"');
    }
    if (Array.isArray(declarations) === false || declarations.length === 0) {
        throw new Error('"declarations" property on declaration must be an Array of declarations');
    }
    const unionDeclarations = flatten_union_declaration_1.flattenUnionDeclaration(declaration);
    let unionCasters;
    const types = unionDeclarations
        .map((d) => d.type)
        .filter((item, index, array) => {
        const nextItems = array.slice(index + 1);
        if (nextItems.length === 0) {
            return true;
        }
        return nextItems.every((nextItem) => item !== nextItem);
    })
        .sort();
    const casterRef = (candidate, register = new Map()) => {
        const results = [];
        for (const [childDeclaration, caster] of unionCasters) {
            const declarationRegister = register.get(childDeclaration);
            const result = caster(candidate, register);
            if (result.isValid === true) {
                return result;
            }
            results.push(result);
        }
        for (const result of results) {
            if (result.invalidations === undefined) {
                throw new Error('invalidations:' + JSON.stringify(result, undefined, 2));
            }
        }
        if (results.every((result) => result.invalidations.every(([path, type, rule]) => rule === 'required'))) {
            return {
                type: 'Union',
                isValid: false,
                invalidations: [[[], 'Union', 'required', true, candidate]],
                candidate
            };
        }
        if (results.every((result) => result.invalidations.every(([path, type, rule]) => path.length === 0 && rule === 'type'))) {
            const actualType = actual_type_1.ctorName(candidate);
            return {
                type: 'Union',
                isValid: false,
                invalidations: [[[], 'Union', 'type', types, actualType]],
                candidate
            };
        }
        const resultsWithoutType = results.filter((result) => result.invalidations.some(([path, type, rule]) => path.length === 0 && rule === 'type') === false);
        return resultsWithoutType.find((result, index, arr) => {
            return arr.every((otherResult) => {
                return result.invalidations.length >= otherResult.invalidations.length;
            });
        });
    };
    circularCache.set(declaration, casterRef);
    unionCasters = unionDeclarations.map((d) => {
        return [d, index_1.createCaster(d, validateOptions, circularCache)];
    });
    return casterRef;
}
exports.unionType = unionType;
